module.exports = __webpack_public_path__ + "static/img/at_1.15c3d82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/at_1.jpg
// module id = vc6D
// module chunks = 1